<template>
    <ac-layout-form
        v-if="canRender"
        title="申请解除"
        @back="back">
        <van-cell-group>
            <div class="fd-input-info">
                <van-field
                    v-model="formData.cSqr"
                    required
                    clearable
                    disabled
                    border
                    input-align="right"
                    label="申请人"
                ></van-field>
                <van-field
                    v-model="formData.cSqxxyy"
                    required
                    readonly
                    label="解除保全事由"
                    right-icon="arrow"
                    input-align="right"
                    placeholder="请选择解除保全事由"
                    @click="showSyPicker = true"
                ></van-field>
                <van-popup v-model="showSyPicker" position="bottom">
                    <van-picker
                        value-key="text"
                        :columns="codeList_804000"
                        show-toolbar
                        :default-index="0"
                        @cancel="showSyPicker = false"
                        @confirm="onSyConfirm"
                    ></van-picker>
                </van-popup>
                <van-field class="van-field--column van-field--no-value"
                           required
                           readonly>
                    <template slot="label">
                        <span>解除保全申请书</span>
                    </template>
                </van-field>
                <!-- <p class="fd-com-warning-tip" v-text="mbxzts"></p> -->
                <!--                    上传组件 -->
                <ac-upload-file
                    v-model="sqsclList"
                    :upload-param="uploadFileParam"
                    :upload-url="uploadFileUrl"
                    :delete-url="deleteFileUrl"
                    :delete-param="deleteFileParam"></ac-upload-file>
            </div>
        </van-cell-group>
        <template slot="footer">
            <van-button
                class="guarantee-button"
                type="info"
                size="normal "
                round plain
                @click="back"
            >
                取消
            </van-button>
            <van-button
                class="guarantee-button submit-btn"
                type="info"
                size="normal"
                round
                @click="saveBqReile"
            >
                提交
            </van-button>
        </template>
    </ac-layout-form>
</template>

<script>
    // 表单布局
    import acLayoutForm from '@/components/app/layout/form/index.vue';
    // 上传文件
    import acUploadFile from '@/components/app/upload-file/index.vue';
    import validate from '../../utils/validator/validator';
    import {
        jcbqYyRule,
        jcbqSqsRule
    } from '../../utils/validator/rules';
    import {mbxzts} from '../../utils/consts';
    import {mapGetters} from 'vuex'
    import {createId} from '@/utils/common';
    import request from "@/api/axios";
    export default {
        data() {
            return {
                formData: {
                    cSqr: '',
                    cSqxxyy: '',
                },
                postData: {
                    // 获取路由中的保全id参数
                    cBqid: this.$route.query.bqid,
                    // 获取路由中的申请编号参数
                    cSqbh: this.$route.query.sqbh,
                    cSqr: '',
                    cSqsid: '',
                    cTjid: '',
                    cSqxxyy: ''
                },
                // 申请书材料列表
                sqsclList: [],
                sqrList: [],
                mbxzts: mbxzts,
                showSyPicker: false,
                // 上传文件url
                uploadFileUrl: 'ssbq/api/sccls/bgdb/sccl',
                // 删除文件url
                deleteFileUrl: 'ssbq/api/sccls/bgsq/bg/delsccl',
                // 材料类型
                cllx: 1,
                // 是否可以渲染
                canRender: false
            }
        },
        components: {
            acLayoutForm,
            acUploadFile
        },
        computed: {
            ...mapGetters(['codeList_804000']),
            // 上传的请求参数
            uploadFileParam() {
                return {
                    // 保全id
                    bqid: this.postData.cBqid,
                    // 担保id
                    dbid: '',
                    // 统计id
                    tjid: this.postData.cTjid,
                    // 材料类型
                    cllx: this.cllx,
                    // 申请书类型
                    sqslx: '303'
                }
            },
            // 删除文件的请求参数
            deleteFileParam() {
                return {
                    cllx: this.cllx
                }
            }
        },
        created() {
            // 请求解除保全事由
            this.$store.dispatch('GetCodeType', 804000);
            // 请求对应的id
            this.gainId();
            // 初始化被申请人
            this.initBqSqrs();
        },
        methods: {

            /**
             * 选择事由
             * @returns {void}
             * */
            onSyConfirm: function (code) {
                // 申请解保事由赋值
                this.formData.cSqxxyy = code.text;
                // 弹层隐藏
                this.showSyPicker = false;
            },

            /**
             * 请求解除保全
             * @returns {void}
             * */
            saveBqReile() {
                // 校验表单
                this.validateForm().then(() => {
                    // 申请解保事由
                    this.postData.cSqxxyy = this.formData.cSqxxyy;
                    this.$axios.post('ssbq/api/bqsq/jc/tj?bqid=' + this.postData.cBqid, this.postData)
                        .then(res => {
                            if (res.code == 200) {
                                history.go(-1);
                                this.$notify({'type': 'success', 'message': '申请解除提交成功'});
                            } else {
                                this.$notify(res.message);
                            }
                        }).catch(function () {
                        this.$notify("系统异常");
                    })
                });
            },

            /**
             * 获取id
             * @returns {void}
             * */
            gainId() {
                // 创建对应的id
                createId().then(id => {
                    // 统计id
                    this.tjid = id;
                    this.postData.cTjid = id;
                });
            },

            /**
             * 初始化保全申请人
             * @returns {void}
             * */
            initBqSqrs() {
                this.$axios.get("ssbq/api/sqrs?bqid=" + this.postData.cBqid)
                    .then(res => {
                        if (res.code == 200) {
                            let sqrs = "";
                            let sqrIds = "";
                            res.data.forEach((item) => {
                                let sqr = {}
                                sqr.cId = item.cId
                                if (item.cSqrlx == "1") {
                                    sqr.sqrmc = item.cSqrxm
                                } else {
                                    sqr.sqrmc = item.cQymc
                                }
                                sqrs = sqrs.concat(sqr.sqrmc, "、");
                                sqrIds = sqrIds.concat(sqr.cId, ",");
                                this.sqrList.push(sqr);
                            });
                            this.formData.cSqr = sqrs.substring(0, sqrs.length - 1);
                            this.postData.cSqr = sqrIds.substring(0, sqrIds.length - 1);
                        } else {
                            this.$notify(res.message);
                        }
                    }).catch(function () {
                    this.$notify("系统异常");
                });
            },

            /**
             * 请求删除申请材料
             * @param {Object} params 请求参数
             * @returns {Promise}
             * */
            requestDelSccl(params) {
                return request({
                    url:'ssbq/api/sccls/bgsq/delsqcl',
                    method:'delete',
                    params: {
                        time: new Date().getTime(),
                        ...params
                    }
                })
            },

            /**
             * 点击返回，则调用取消解除保全
             * @returns {void}
             * */
            back() {
                // 如果上传材料，则需要进行相应的删除
                if (!this.sqsclList.length) {
                    // 返回上一级
                    history.go(-1);
                    return;
                }
                // 删除上传材料再返回
                this.requestDelSccl({
                    cDbid: '',
                    isDeldbl: false,
                    isDelsqs: false,
                    // 变更id
                    cBgid: this.tjid,
                }).then(() => {
                    history.go(-1);
                }).catch(() => {
                    this.$notify("系统异常");
                });
            },

            /**
             * 校验表单
             * @returns {Promise}
             * */
            validateForm() {
                let descriptor = {
                    // 申请原因
                    sqyy: jcbqYyRule,
                    // 申请书材料 必填
                    sqs: jcbqSqsRule
                };
                const validated = validate(descriptor, {
                    // 申请原因
                    sqyy: this.formData.cSqxxyy,
                    // 申请书材料 必填
                    sqs: this.sqsclList
                });
                return validated
            }
        },
        //进入该页面时，刷新页面，要不上传会导致页面刷新
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if(from.name == 'myPreservation'){
                    // 如果是从保全列表过来的需要刷新下页面，否则在手机上上传会有问题
                    window.location.reload();
                }
                // 可以进行渲染
                vm.canRender = true;
            });
        }
    }
</script>
